import type { IMetricCalcMode } from '@/pages/intelligence/types/common';

const CALC_METRIC_LOCALE_KEY_PREFIX = 'dbi_calc_metric';

/**
 *
 * @param metric 指标（key）
 * @param calcMode 指标数据计算方式（key），目前知道的有sum、avg、max，可以自行增加
 * @returns Sum Physical Revenue、Max PCU 这种组合计算指标文案的 翻译，调用这个方法 获取 对应翻译的key
 */
export const getCalcMetricTranslateKey = (metric: string, calcMode: IMetricCalcMode): string =>
  `${CALC_METRIC_LOCALE_KEY_PREFIX}_${calcMode}_${metric}`;
